import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {AppComponent } from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {AppConfigurationService} from '../common/app-config/app-configuration.service';
import { AppRoutingModule } from './app-routing.module';
import {RouterModule} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_BASE_HREF, CommonModule} from '@angular/common';
import {HttpHelpersModule} from '../common/http-helpers/http-helpers.module';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import {MomentModule} from 'angular2-moment'; // optional, provides moment-style pipes for date formatting
import {PopupModule} from '@progress/kendo-angular-popup';
import {CldrIntlService, IntlService} from '@progress/kendo-angular-intl';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {TranslateModule} from '../common/translate/translate.module';
import {MaskApplierService, NgxMaskModule} from 'ngx-mask';
import {WindowModule} from '@progress/kendo-angular-dialog';
import {LanguageSelectionModule} from '../common/translate/language.selection.module';
import {AppAuthModule} from "../app-auth/app-auth.module";
import {MockModule} from "../common/mock/modules/mock.module";
import {LicenseNotFoundComponent} from "./license/license.no.found/license.not.found.component";
import {MessageService, RTL} from "@progress/kendo-angular-l10n";

require('./kendo.locale.imports');

export function initConfigFactory(appConfigService: AppConfigurationService) {
  return () => appConfigService.loadConfig();
}

export function baseHrefFactory() {
  const baseResourceUrl = window['__patient_portal_global_vars__'].baseResourceUrl;
  if (baseResourceUrl === '/') {
    return baseResourceUrl;
  }
  const expectedBaseHref = baseResourceUrl.split('/')[1];
  const currentBaseHref = window.location.pathname.split('/')[1];
  if (expectedBaseHref.toLowerCase() === currentBaseHref.toLowerCase() && expectedBaseHref !== currentBaseHref) {
    // The two base hrefs are the same, but not the same case.
    // Redirect the user to the correct base href.
    const newLocation = window.location.href.replace(currentBaseHref, expectedBaseHref);
    window.location.replace(newLocation);
  }
  return '/' + expectedBaseHref + '/';
}

@NgModule({
  declarations: [
    AppComponent, LicenseNotFoundComponent
  ],
  imports: [
    // tslint:disable-next-line:max-line-length
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    RouterModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpHelpersModule,
    AppAuthModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    PopupModule,
    NgxMaterialTimepickerModule,
    TranslateModule,
    NgxMaskModule.forRoot(),
    WindowModule,
    LanguageSelectionModule,
    MockModule
  ],

  providers: [
    {provide: APP_BASE_HREF, useFactory: baseHrefFactory},
    {provide: IntlService, useExisting: CldrIntlService},
    {provide: LOCALE_ID, useValue: 'en-US'},
    {provide: RTL, useValue: false},
    AppConfigurationService,
    CldrIntlService,
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfigFactory,
      deps: [AppConfigurationService],
      multi: true,
      useExisting: true
    },
    MaskApplierService
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }


